import GoogleMapsLink from 'helpers/googleMapsLink';
import React from 'react';
import PropTypes from 'prop-types';
import { MdPlace } from 'react-icons/md';

const ProjectLocationRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  return (
    <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-max-w-full">
      <MdPlace size={13} className="tw-text-slate-400 tw-shrink-0" />
      <span className="tw-truncate"><GoogleMapsLink address={value} /></span>
    </span>
  );
};

ProjectLocationRenderer.propTypes = { value: PropTypes.string };

export default ProjectLocationRenderer;
